import { useEffect, useRef } from "react";
import Tooltip from "bootstrap/js/dist/tooltip";
import {Badge, NavLink } from "react-bootstrap";
import {
  formatImage,
  formatStatus,
  formatActions
} from "./Formatters";
import RatingStars from "./RatingStars";

function ProductCard({
  product,
  isSelected,
  onToggle,
  detailsExpanded,
  onToggleDetails
}) {
  const marketplaces = JSON.parse(localStorage.getItem("marketplaceOptions"));
  const mtpl=localStorage.getItem("selectedMarketplace");

  return (
    <div
      className={`product-card card ${isSelected ? 'selected' : ''}`}
      onClick={onToggle}
    >

      <div className="card-header">
        <div className="d-flex align-items-center gap-2">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onToggle}
            onClick={e => e.stopPropagation()}
          />
          {product.asin}
        </div>
          {formatActions(product)}
      </div>

      <div className="card-img-top">
        {formatStatus(product.status)}
        {formatImage(product.img)}
        { product.bsr ? (
            <Badge className="bsr">BSR: {product.bsr}</Badge>
        ) : ''
        }
        <RatingStars rating={product.rating} reviews={product.reviews} />
      </div>

      <div className="card-body meta">
          {product.fnsku ? <div><label>FNSKU:</label> {product.fnsku}</div> : null}
          <div><label>SKU:</label> {product.sku}</div>
      </div>

      <div className={`card-body detail collapse ${detailsExpanded ? 'show' : ''}`}>
        <TitleWithTooltip title={product.title} />
        <div className="kpi row">
          <div className="col">
            {product.sales ? <span className="sales"><label>Sales:</label> {product.sales}</span> : null}
            {product.adsales ? <span className="sales"><label>AD Sales:</label> {product.adsales}</span> : null}
            {product.price ? <span className="price"><label>Price:</label> {product.price}</span> : null}
            {product.fee ? <span className="fee"><label>FBA fee:</label> {product.fee}</span> : null}
            {product.cost ? <span  className="cost"><label>Cost:</label> {product.cost}</span> : null}
            {product.profit ? <span><label>Profit:</label> {product.profit}</span> : null}
          </div>
          <div className="col">
            {product.stock ? <span><label>Stock:</label> {product.stock}</span> : null}
            {product.reserved ? <span><label>Reserved:</label> {product.reserved}</span> : null}
            {product.inbound ? <span><label>Inbound:</label> {product.inbound}</span> : null}
            {product.prep_stock ? <span><label>Prep:</label> {product.prep_stock}</span> : null}
            {product.prep_inbound ? <span><label>To prep:</label> {product.prep_inbound}</span> : null}
            {product.awd_stock ? <span><label>AWD:</label> {product.awd_stock}</span> : null}
            {product.awd_inbound ? <span><label>To AWD:</label> {product.awd_inbound}</span> : null}
          </div>
        </div>
      </div>

      <button
        className={`btn btn-sm btn-light toggle-details ${detailsExpanded ? 'expanded' : 'collapsed'}`}
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggleDetails();
        }}
      >
        <i className="fa-solid fa-angle-down"></i>
      </button>

    </div>
  );
}

function TitleWithTooltip({ title }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const tooltip = new Tooltip(ref.current, {
      title,
      placement: "top",
      trigger: "hover focus"
    });

    return () => tooltip.dispose();
  }, [title]);

  return (
    <div
      ref={ref}
      className="title"
      tabIndex={0}
      aria-label={title}
    >
      {title}
    </div>
  );
}


export default ProductCard;
